import { z } from "zod";

// Lista de las contraseñas más comunes para prevenir su uso
const COMMON_PASSWORDS = new Set([
  "123456", "password", "123456789", "12345678", "12345", "1234567", "password1",
  "123123", "1234567890", "000000", "abc123", "qwerty", "iloveyou", "monkey",
  "dragon", "111111", "baseball", "letmein", "master", "sunshine", "ashley",
  "bailey", "passw0rd", "shadow", "123123123", "654321", "superman", "qazwsx",
  "admin", "Admin123", "Admin@123", "root", "pass", "test", "guest", "password123",
  "1111", "qwerty123", "admin123", "password!", "P@ssw0rd", "Welcome1", "changeme"
]);

// Esquema de validación de contraseña simplificado (mínimo 6 caracteres)
const strongPasswordSchema = z.string()
  .min(6, "La contraseña debe tener al menos 6 caracteres")
  .max(128, "La contraseña no puede exceder 128 caracteres")
  .refine(
    (password) => !COMMON_PASSWORDS.has(password.toLowerCase()),
    "Esta contraseña es demasiado común. Por favor elige una más segura"
  );

export const signUpSchema = z.object({
  firstName: z.string()
    .trim()
    .min(2, "El nombre debe tener al menos 2 caracteres")
    .max(50, "El nombre no puede exceder 50 caracteres"),
  lastName: z.string()
    .trim()
    .min(2, "El apellido debe tener al menos 2 caracteres")
    .max(50, "El apellido no puede exceder 50 caracteres"),
  email: z.string()
    .trim()
    .email("Correo electrónico inválido")
    .max(255, "El correo no puede exceder 255 caracteres")
    .toLowerCase(),
  password: strongPasswordSchema,
  confirmPassword: z.string()
}).refine((data) => data.password === data.confirmPassword, {
  message: "Las contraseñas no coinciden",
  path: ["confirmPassword"],
});

export const signInSchema = z.object({
  email: z.string()
    .trim()
    .email("Correo electrónico inválido")
    .max(255, "El correo no puede exceder 255 caracteres"),
  password: z.string()
    .min(1, "La contraseña es requerida"),
});

export const forgotPasswordSchema = z.object({
  email: z.string()
    .trim()
    .email("Correo electrónico inválido")
    .max(255, "El correo no puede exceder 255 caracteres"),
});

export const resetPasswordSchema = z.object({
  password: strongPasswordSchema,
  confirmPassword: z.string()
}).refine((data) => data.password === data.confirmPassword, {
  message: "Las contraseñas no coinciden",
  path: ["confirmPassword"],
});

export type SignUpInput = z.infer<typeof signUpSchema>;
export type SignInInput = z.infer<typeof signInSchema>;
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
